var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLeftArrowIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 16,
    viewBox: "0 0 24 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24 7.74194C24 7.97005 23.9097 8.18882 23.749 8.35012C23.5882 8.51142 23.3702 8.60203 23.1429 8.60203L2.92763 8.60203L8.32214 14.0137C8.48308 14.1752 8.5735 14.3943 8.5735 14.6227C8.5735 14.8511 8.48308 15.0701 8.32214 15.2316C8.16121 15.3931 7.94293 15.4839 7.71532 15.4839C7.48772 15.4839 7.26945 15.3931 7.10851 15.2316L0.251801 8.35088C0.171984 8.27099 0.108658 8.17607 0.0654488 8.07158C0.0222416 7.96709 0 7.85507 0 7.74194C0 7.6288 0.0222416 7.51678 0.0654488 7.41229C0.108658 7.3078 0.171984 7.21289 0.251801 7.13299L7.10851 0.252234C7.26945 0.0907311 7.48772 -5.38128e-09 7.71532 0C7.94293 5.38127e-09 8.16121 0.0907311 8.32214 0.252234C8.48308 0.413737 8.5735 0.632782 8.5735 0.861181C8.5735 1.08958 8.48308 1.30863 8.32214 1.47013L2.92763 6.88184L23.1429 6.88184C23.3702 6.88184 23.5882 6.97246 23.749 7.13376C23.9097 7.29506 24 7.51383 24 7.74194Z",
    fill: "#42BF76"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftArrowIcon);
export default __webpack_public_path__ + "static/media/left-arrow-icon.b8887b8658004523614ea94199d02edf.svg";
export { ForwardRef as ReactComponent };